export const uploadFileTypes = [
  {id: 10, label: 'צילום חזית בניין'},
  {id: 13, label: 'תשריט מהיתר'},
  {id: 12, label: 'תשריט בית משותף'},
  {id: 16, label: 'תקנון בית משותף'},
  {id: 1, label: 'נסח טאבו'},
  {id: 18, label: 'תקריב דירה מתשריט ההיתר'},
  {id: 19, label: 'אישור זכויות מהמנהל'},
  {id: 20, label: 'דף מידע תכנוני'},
  {id: 25, label: 'צו בית משותף'},
  {id: 15, label: 'מסמכי רישוי'},
  {id: 23, label: 'תעודת גמר'},
  {id: 22, label: 'טופס 4'},
  {id: 24, label: 'מבנה מסוכן'},
  {id: 11, label: 'תמונות מביקור בנכס'},
  {id: 21, label: 'דוח סופי חתום'},
  {id: 17, label: 'אחר'},
];
